import { motion } from "framer-motion";
import styled from "styled-components";
import { Text } from "../../../Text/Text.js";

export const AnimatedCustomText = styled(motion(Text))`
    white-space: nowrap;
    will-change: width;
    overflow-x: hidden;
    min-width: 0;
    flex: 0 0 auto;
    margin-top: ${({ theme }) => `${theme.rem(-0.125)}`};
`;

export const CloseAllToastsOuter = styled.div`
    align-items: center;
    box-shadow: ${(props) => props.theme.shadows.smallItem.default};
    justify-content: flex-start;
    cursor: pointer;
    display: flex;
    height: ${({ theme }) => theme.spacing[32]};
    left: calc(100% + ${({ theme }) => theme.spacing[4]});
    padding: 0 ${(props) => props.theme.rem(0.625)};
    border-radius: ${({ theme }) => theme.radius.xs};
    position: absolute;
    top: 0;
    width: max-content;
`;
